module.exports = __webpack_public_path__ + "static/media/instagram.f73909b7.svg";